import getStorageUser from "../middlewares/GetStorageUser"


export const useUser = () => {
    const getUser = async () => {
        try {
            const user = getStorageUser()
        return user;
        } catch (error) {
            console.log(error);
        }
    }


    return {
        // user
        getUser,
    }

}
